export default function Services() {
  const services = [
    {
      icon: 'ri-scissors-line',
      title: 'Mens Classic Cut',
      description: 'From tapers to fades, our master barbers deliver precision cuts that honor traditional barbering techniques while keeping you fresh and modern.',
      price: 'Starting at $50'
    },
    {
      icon: 'ri-contrast-drop-line',
      title: 'Beard Sculpting',
      description: 'Expert beard grooming and shaping services. We trim, line up, and sculpt your beard to perfection, enhancing your natural features.',
      price: 'Starting at $25'
    },
    {
      icon: 'ri-fire-line',
      title: 'Line Up',
      description: 'Clean, sharp, and precise. Our barbers define your edges and hairline with expert skill, giving your look a polished finish that turns heads.',
      price: 'Starting at $30'
    }
  ];

  return (
    <section id="services" className="py-24 bg-neutral-900">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <p className="text-amber-500 text-sm font-bold tracking-wider mb-4">WHAT WE OFFER</p>
          <h2 className="text-5xl md:text-6xl font-black text-white leading-tight">
            SIGNATURE<br />SERVICES
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-neutral-950 border border-neutral-800 p-10 rounded-2xl hover:border-amber-500/30 transition-all group">
              <div className="w-16 h-16 flex items-center justify-center mb-6 bg-amber-500/10 rounded-xl group-hover:bg-amber-500/20 transition-colors">
                <i className={`${service.icon} text-4xl text-amber-500`}></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">{service.title}</h3>
              <p className="text-stone-400 text-base leading-relaxed mb-6">{service.description}</p>
              <p className="text-amber-500 font-bold text-lg">{service.price}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
